

















import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import moment from "moment";
import ReusableForm from "../components/forms/ReusableForm.vue";
import SupplierHeaderFieldRecogChart from "../components/charts/SupplierHeaderFieldRecog.vue";
import AnalyticsStore from "../store/analytics.store";

@Component({
  components: {
    "reusable-form": ReusableForm,
    "supplier-header-field-recog-chart": SupplierHeaderFieldRecogChart
  }
})
export default class Recognition extends Vue {
  private readonly analyticsStore: AnalyticsStore = getModule(
    AnalyticsStore,
    this.$store
  );

  private todayDate = moment()
    .format()
    .toString()
    .substring(0, 10);

  private get dateRange() {
    return this.analyticsStore.getDateRange;
  }

  private get selectedSite() {
    return this.analyticsStore.getSelectedSite;
  }

  handleSelectionChange(selection: {
    startDate: string;
    endDate: string;
    site: string;
  }) {
    const dateRange: { startDate: string; endDate: string } = {
      startDate: selection.startDate,
      endDate: selection.endDate
    };
    this.analyticsStore.updateDateRange(dateRange);
    this.analyticsStore.updateSelectedSite(selection.site);
    this.analyticsStore.clickAnalyticsSearchButton();
  }
}
